import { reduxForm } from 'redux-form';
import Component from './UserForm';
import { validate, initialValues } from './schema';

const Form = reduxForm({
  form: 'userForm',
  initialValues,
  validate,
})(Component);

export default Form;
